import { RelatedPartyRoleSettingsDto, RelatedPartyRoleUpdateDto } from 'types/compliance';
import { portalAPI } from './portalAPI';

const APIRelatedPartyRoleSettingsSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getRelatedPartyRoleSettings: builder.query<RelatedPartyRoleSettingsDto, void>({
            query: () => '/v1/compliance-settings/related-party-roles',
        }),
        updateRelatedPartyRoleSettings: builder.mutation<
            RelatedPartyRoleSettingsDto,
            { roles: RelatedPartyRoleUpdateDto[] }
        >({
            query: (body) => ({
                url: '/v1/compliance-settings/related-party-roles',
                method: 'PUT',
                body,
            }),
            // The PUT answers with the settings as the GET does, so the cache takes them from the answer
            // rather than fetching them again and showing the old rows meanwhile.
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(
                    APIRelatedPartyRoleSettingsSlice.util.upsertQueryData(
                        'getRelatedPartyRoleSettings',
                        undefined,
                        data
                    )
                );
            },
        }),
    }),
    overrideExisting: false,
});

export const { useGetRelatedPartyRoleSettingsQuery, useUpdateRelatedPartyRoleSettingsMutation } =
    APIRelatedPartyRoleSettingsSlice;
